'use client';

import Botpoison from '@botpoison/browser';
import { startTransition, useActionState, useCallback } from 'react';
const botpoison = new Botpoison({
  publicKey: process.env.NEXT_PUBLIC_BOTPOISON_KEY as string
});

//from https://www.nico.fyi/blog/reset-state-from-react-useactionstate

export function useResettableActionState<State, Payload>(action: (state: Awaited<State>, payload: Payload) => State | Promise<State>, initialState: Awaited<State>, permalink?: string): [state: Awaited<State>, dispatch: (payload: Omit<Payload, '_botpoison'> | null) => void, isPending: boolean, reset: () => void] {
  const [state, submit, isPending] = useActionState(async (state: Awaited<State>, payload: Payload | null) => {
    if (!payload) {
      return initialState;
    }
    const {
      solution
    } = await botpoison.challenge();
    const data = await action(state, {
      ...payload,
      _botpoison: solution
    });
    return data;
  }, initialState, permalink);
  const reset = useCallback(() => {
    startTransition(() => {
      submit(null);
    });
  }, [submit]);
  return [state, submit as (payload: Omit<Payload, '_botpoison'> | null) => void, isPending, reset];
}